// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ploYM","mainFooter":"styles_mainFooter__ixEHd","footerLinkTop":"styles_footerLinkTop__ycbo9"};